export default __webpack_public_path__ + "static/media/fillet.cb4a2f5c.svg";